function DeviceClusterDevice(aId, aDeviceId, aIsActive) {
    "use strict";

    this.__type = 'DeviceClusterDevice:www.veritracks.com';
    this.Id = -1;
    this.Version = 0;

    this.DeviceClusterId = aId;
    this.DeviceId = aDeviceId;
    this.IsActive = aIsActive;
    this.TransactionId = '';
}
if (typeof exports !== 'undefined') {
    module.exports = DeviceClusterDevice;
}